// source: exQryOrders.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var exOrderInfo_pb = require('./exOrderInfo_pb.js');
goog.object.extend(proto, exOrderInfo_pb);
goog.exportSymbol('proto.common.model.ExQryOrders', null, global);
goog.exportSymbol('proto.common.model.ExQryOrders.Data', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExQryOrders = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.model.ExQryOrders, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExQryOrders.displayName = 'proto.common.model.ExQryOrders';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExQryOrders.Data = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.model.ExQryOrders.Data.repeatedFields_, null);
};
goog.inherits(proto.common.model.ExQryOrders.Data, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExQryOrders.Data.displayName = 'proto.common.model.ExQryOrders.Data';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExQryOrders.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExQryOrders.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExQryOrders} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExQryOrders.toObject = function(includeInstance, msg) {
  var f, obj = {
exchange: jspb.Message.getFieldWithDefault(msg, 1, 0),
data: (f = msg.getData()) && proto.common.model.ExQryOrders.Data.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExQryOrders}
 */
proto.common.model.ExQryOrders.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExQryOrders;
  return proto.common.model.ExQryOrders.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExQryOrders} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExQryOrders}
 */
proto.common.model.ExQryOrders.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExchange(value);
      break;
    case 2:
      var value = new proto.common.model.ExQryOrders.Data;
      reader.readMessage(value,proto.common.model.ExQryOrders.Data.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExQryOrders.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExQryOrders.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExQryOrders} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExQryOrders.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExchange();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.common.model.ExQryOrders.Data.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.model.ExQryOrders.Data.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExQryOrders.Data.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExQryOrders.Data.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExQryOrders.Data} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExQryOrders.Data.toObject = function(includeInstance, msg) {
  var f, obj = {
currentpage: jspb.Message.getFieldWithDefault(msg, 1, 0),
pagesize: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalnum: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalpage: jspb.Message.getFieldWithDefault(msg, 4, 0),
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    exOrderInfo_pb.ExOrderInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExQryOrders.Data}
 */
proto.common.model.ExQryOrders.Data.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExQryOrders.Data;
  return proto.common.model.ExQryOrders.Data.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExQryOrders.Data} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExQryOrders.Data}
 */
proto.common.model.ExQryOrders.Data.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentpage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesize(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalnum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalpage(value);
      break;
    case 5:
      var value = new exOrderInfo_pb.ExOrderInfo;
      reader.readMessage(value,exOrderInfo_pb.ExOrderInfo.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExQryOrders.Data.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExQryOrders.Data.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExQryOrders.Data} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExQryOrders.Data.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentpage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPagesize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalnum();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalpage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      exOrderInfo_pb.ExOrderInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 currentPage = 1;
 * @return {number}
 */
proto.common.model.ExQryOrders.Data.prototype.getCurrentpage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExQryOrders.Data} returns this
 */
proto.common.model.ExQryOrders.Data.prototype.setCurrentpage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 pageSize = 2;
 * @return {number}
 */
proto.common.model.ExQryOrders.Data.prototype.getPagesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExQryOrders.Data} returns this
 */
proto.common.model.ExQryOrders.Data.prototype.setPagesize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 totalNum = 3;
 * @return {number}
 */
proto.common.model.ExQryOrders.Data.prototype.getTotalnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExQryOrders.Data} returns this
 */
proto.common.model.ExQryOrders.Data.prototype.setTotalnum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 totalPage = 4;
 * @return {number}
 */
proto.common.model.ExQryOrders.Data.prototype.getTotalpage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExQryOrders.Data} returns this
 */
proto.common.model.ExQryOrders.Data.prototype.setTotalpage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated ExOrderInfo items = 5;
 * @return {!Array<!proto.common.model.ExOrderInfo>}
 */
proto.common.model.ExQryOrders.Data.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.common.model.ExOrderInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, exOrderInfo_pb.ExOrderInfo, 5));
};


/**
 * @param {!Array<!proto.common.model.ExOrderInfo>} value
 * @return {!proto.common.model.ExQryOrders.Data} returns this
*/
proto.common.model.ExQryOrders.Data.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.common.model.ExOrderInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.model.ExOrderInfo}
 */
proto.common.model.ExQryOrders.Data.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.common.model.ExOrderInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.ExQryOrders.Data} returns this
 */
proto.common.model.ExQryOrders.Data.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int32 exchange = 1;
 * @return {number}
 */
proto.common.model.ExQryOrders.prototype.getExchange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExQryOrders} returns this
 */
proto.common.model.ExQryOrders.prototype.setExchange = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Data data = 2;
 * @return {?proto.common.model.ExQryOrders.Data}
 */
proto.common.model.ExQryOrders.prototype.getData = function() {
  return /** @type{?proto.common.model.ExQryOrders.Data} */ (
    jspb.Message.getWrapperField(this, proto.common.model.ExQryOrders.Data, 2));
};


/**
 * @param {?proto.common.model.ExQryOrders.Data|undefined} value
 * @return {!proto.common.model.ExQryOrders} returns this
*/
proto.common.model.ExQryOrders.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.model.ExQryOrders} returns this
 */
proto.common.model.ExQryOrders.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.model.ExQryOrders.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.common.model);
